import * as React from 'react';
import { getMinutes } from 'owa-datetime';
import { GridLineItemProps } from './GridLinesFragment';

const styles = require('./GridLine.scss');
const getClassName = require('classnames/bind').bind(styles);

/** Additional class names to apply to grid lines */
export interface GridLineClassNames {
    /** Class name to apply to grid lines that are exactly in the hour */
    inHour?: string;

    /** Class name to apply to incremental grid lines (not in the hour) */
    incremental?: string;
}

/**
 * A single grid line in day/week view. A grid line is a simple component
 * with no labels, just the line
 */
export function GridLine(props: GridLineItemProps<GridLineClassNames>) {
    const { time, style, classNames } = props;
    const inTheHour = getMinutes(time) == 0;

    const className = getClassName(
        styles.gridLine,
        { gridLine60: inTheHour },
        { gridLineInc: !inTheHour },
        classNames && (inTheHour ? classNames.inHour : classNames.incremental)
    );

    return <div className={className} style={style} />;
}
